import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.3667 0.166656H11.6333V11.6333H0.166672V17.3667H11.6333V28.8333H17.3667V17.3667H28.8333V11.6333H17.3667V0.166656Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
